module.exports = __webpack_public_path__ + "img/a114.dc1fbcad.png";